import { useGraphContext } from "../GraphContext";
import { useResetContext} from '../../src/components/ResetContext';

const useInvokeAgent = () => {
  const { updateGraphData } = useGraphContext();
  const {resetdata, updateresetdata} = useResetContext();

  const getBaseURL = () => {
    if (window.location.hostname === "simbaanalytics-dev.rio.cloud") {
      return "https://26ovsbph5oz6xpn2fgscmr5x5i0socao.lambda-url.eu-west-1.on.aws";
    } else if (window.location.hostname === "bev-dev.simbaanalytics-dev.rio.cloud") {
      return "https://spv3toxlwj.execute-api.eu-west-1.amazonaws.com/test_cognito";
    } else if (window.location.hostname === "bev-prod.simbaanalytics-dev.rio.cloud") {
      return "https://dnz0zln7l2.execute-api.eu-west-1.amazonaws.com/prod";
    } else {
      return "http://localhost:8080";
    }
  };

  const invokeAgent = async ({ selectedValues,kpi = "daily mileage", segment = "eMDT", timestamp = "daily" }) => {
    try {
      const baseURL = getBaseURL();
        const token = localStorage.getItem("idToken");

        if (!token) {
          console.error("No ID token found!");
          return;
        }

        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };

        const body = {selectedValues,timestamp,resetdata};

        const startResponse = await fetch(`${baseURL}/invoke-agent`, {
          method: "POST",
          headers,
          body: JSON.stringify(body),
        });

      const { task_id } = await startResponse.json();

      let retries = 0;
      const maxRetries = 35;
      let result = null;

      while (retries < maxRetries) {
        const pollResponse = await fetch(`${baseURL}/invoke-agent/result/${task_id}`, {
          headers,
        });
        const data = await pollResponse.json();

        if (data.status === "done") {
          result = data.result;
          break;
        }

        await new Promise((res) => setTimeout(res, 2000));
        retries += 1;
      }

      if (!result) {
        console.warn("Agent insight generation timed out.");
        updateGraphData(prev => ({
          ...prev,
          agent_insight: "Insight generation timed out. Please try again later.",
        }));
      } else {
        updateGraphData(prev => ({
          ...prev,
          agent_insight: result,
        }));
      }
    } catch (error) {
      console.error("Error in invokeAgent:", error.message);
    }
  };

  return invokeAgent;
};

export default useInvokeAgent;
